import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import App from './Gestionale';
import { db } from './firebase';
import {collection, getDocs} from "./firebase-shim";

const NAS_URL = "";

function Root() {
  const [utenti, setUtenti] = useState([]);
  const [utenteSelezionato, setUtenteSelezionato] = useState(null);
  const [utente, setUtente] = useState(null);
  const [pin, setPin] = useState('');
  const [errore, setErrore] = useState('');

  useEffect(() => {
    const saved = localStorage.getItem('bertoc_utente');
    if (saved) { setUtente(JSON.parse(saved)); return; }
    // FIX_UTENTI_PUBBLICI_v1: endpoint pubblico, no auth richiesta
    fetch('/api/utenti-pubblici')
      .then(r => r.ok ? r.json() : [])
      .then(lista => setUtenti(Array.isArray(lista) ? lista : []))
      .catch(() => {});
  }, []);

  // ============================================================
  // Login via backend con fallback locale
  // ============================================================
  async function loginViaBackend(pinDaVerificare, nomeFiltro) {
    const body = { pin: String(pinDaVerificare) };
    if (nomeFiltro) body.nomeFiltro = nomeFiltro;
    const resp = await fetch(`${NAS_URL}/api/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
    if (resp.status === 401) return null;
    if (resp.status === 429) throw new Error('Troppi tentativi, riprova tra 1 minuto');
    if (!resp.ok) throw new Error('Errore backend ' + resp.status);
    const data = await resp.json();
    if (!data.token || !data.utente) throw new Error('Risposta backend incompleta');
    return data;
  }

  const login = async () => {
    if (!utenteSelezionato) { setErrore('Seleziona un utente'); return; }

    let metodo = 'backend';
    let utenteOk = null;
    let token = null;

    try {
      // PROVA BACKEND
      const ris = await loginViaBackend(pin, utenteSelezionato.nome);
      if (ris) {
        utenteOk = ris.utente;
        token = ris.token;
      }
    } catch (errBackend) {
      console.warn('[LOGIN] Backend non disponibile, fallback locale:', errBackend.message);
      metodo = 'fallback_locale';
      // FALLBACK: confronto locale come prima
      if (utenteSelezionato.pin === pin) {
        utenteOk = utenteSelezionato;
      }
    }

    if (utenteOk) {
      // Salva sessione (compatibile con codice esistente)
      localStorage.setItem('bertoc_utente', JSON.stringify(utenteOk));
      // Salva JWT se disponibile (per chiamate autenticate future)
      if (token) {
        try {
          localStorage.setItem('bertoc_jwt', token);
          localStorage.setItem('bertoc_jwt_user', JSON.stringify({
            uid: utenteOk._id,
            nome: utenteOk.nome,
            ruolo: utenteOk.ruolo,
            savedAt: Date.now(),
          }));
        } catch(e) { console.warn('localStorage error:', e.message); }
      }
      console.log('[LOGIN] OK via', metodo, '- utente:', utenteOk.nome, '(', utenteOk.ruolo, ')');
      setUtente(utenteOk);
      setErrore('');
    } else {
      setErrore('PIN non valido');
      setPin('');
    }
  };

  const logout = () => {
    localStorage.removeItem('bertoc_utente');
    setUtente(null);
    setUtenteSelezionato(null);
    setPin('');
  };

  if (utente) return <App utente={utente} onLogout={logout} />;

  return (
    <div style={{ minHeight:'100vh', background:'#0d0f18', display:'flex', alignItems:'center', justifyContent:'center', fontFamily:"'DM Sans',sans-serif" }}>
      <div style={{ background:'#151929', border:'1px solid #2a2e45', borderRadius:16, padding:'40px', width:360, textAlign:'center' }}>
        <div style={{ fontFamily:"'Syne',sans-serif", fontWeight:800, fontSize:32, color:'#f5a623', marginBottom:2 }}>b</div>
        <div style={{ fontFamily:"'Syne',sans-serif", fontWeight:800, fontSize:20, color:'#e8eaf2', marginBottom:4 }}>BertocProject</div>
        <div style={{ fontSize:11, color:'#4a5068', marginBottom:28, letterSpacing:2, textTransform:'uppercase' }}>Gestionale</div>

        {!utenteSelezionato ? (
          <div>
            <div style={{ fontSize:13, color:'#7b82a0', marginBottom:16 }}>Chi sei?</div>
            <div style={{ display:'flex', flexWrap:'wrap', gap:12, justifyContent:'center' }}>
              {utenti.map(u => (
                <button key={u._id} onClick={() => { setUtenteSelezionato(u); setErrore(''); }}
                  style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:8, padding:'14px 18px', borderRadius:12, border:'1px solid #2a2e45', background:'#0d0f18', cursor:'pointer', minWidth:90, transition:'all 0.15s' }}
                  onMouseEnter={e => e.currentTarget.style.borderColor = u.colore||'#f5a623'}
                  onMouseLeave={e => e.currentTarget.style.borderColor = '#2a2e45'}>
                  <div style={{ width:44, height:44, borderRadius:'50%', background: u.colore||'#888', display:'flex', alignItems:'center', justifyContent:'center', fontFamily:"'Syne',sans-serif", fontWeight:800, fontSize:20, color:'#fff' }}>
                    {(u.nome||'?')[0]}
                  </div>
                  <div style={{ fontSize:13, color:'#e8eaf2', fontWeight:600 }}>{u.nome}</div>
                </button>
              ))}
            </div>
            {utenti.length === 0 && (
              <div style={{ color:'#4a5068', fontSize:13, marginTop:16 }}>Caricamento utenti...</div>
            )}
          </div>
        ) : (
          <div>
            <div style={{ display:'flex', alignItems:'center', gap:12, justifyContent:'center', marginBottom:20, padding:'12px 16px', background:'#0d0f18', borderRadius:12, border:`1px solid ${utenteSelezionato.colore||'#f5a623'}44` }}>
              <div style={{ width:44, height:44, borderRadius:'50%', background: utenteSelezionato.colore||'#888', display:'flex', alignItems:'center', justifyContent:'center', fontFamily:"'Syne',sans-serif", fontWeight:800, fontSize:20, color:'#fff', flexShrink:0 }}>
                {(utenteSelezionato.nome||'?')[0]}
              </div>
              <div style={{ textAlign:'left', flex:1 }}>
                <div style={{ fontFamily:"'Syne',sans-serif", fontWeight:700, fontSize:16, color:'#e8eaf2' }}>{utenteSelezionato.nome}</div>
                <div style={{ fontSize:11, color:'#4a5068' }}>{utenteSelezionato.ruolo==='titolare'?'Titolare':'Operaio'}</div>
              </div>
              <button onClick={() => { setUtenteSelezionato(null); setPin(''); setErrore(''); }}
                style={{ background:'none', border:'none', color:'#4a5068', cursor:'pointer', fontSize:20, lineHeight:1 }}>✕</button>
            </div>
            <input
              type="password" inputMode="numeric" maxLength={8}
              placeholder="PIN" value={pin}
              onChange={e => setPin(e.target.value.replace(/\D/g,''))}
              onKeyDown={e => e.key==='Enter' && login()}
              autoFocus
              style={{ width:'100%', padding:'14px', borderRadius:10, border:'1px solid #2a2e45', background:'#0d0f18', color:'#e8eaf2', fontSize:24, textAlign:'center', letterSpacing:10, marginBottom:12, outline:'none', boxSizing:'border-box' }}
            />
            {errore && <div style={{ color:'#f06060', fontSize:13, marginBottom:12 }}>{errore}</div>}
            <button onClick={login}
              style={{ width:'100%', padding:'14px', borderRadius:10, background: utenteSelezionato.colore||'#f5a623', border:'none', color:'#111', fontFamily:"'Syne',sans-serif", fontWeight:800, fontSize:16, cursor:'pointer' }}>
              Accedi →
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Root />);
